import { render, staticRenderFns } from "./PointList.vue?vue&type=template&id=6854bac4&scoped=true"
import script from "./PointList.vue?vue&type=script&lang=js"
export * from "./PointList.vue?vue&type=script&lang=js"
import style0 from "./PointList.vue?vue&type=style&index=0&id=6854bac4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6854bac4",
  null
  
)

export default component.exports